import { Menu } from 'lucide-react';
import { Link } from 'react-router-dom';
import authService from '../../lib/auth';
import { UserMenu } from './UserMenu';

/**
 * Thin admin top bar: the drawer trigger below `lg`, a way back to the public
 * site, and who is signed in.
 *
 * The "System Online" dot is gone — it was green regardless of whether anything
 * was actually reachable. The notification bell is gone with it until there is a
 * real source (CONTRACT.md §2.5).
 */
export const AdminHeader = ({ onMenuClick }: { onMenuClick: () => void }) => {
  const user = authService.getUser();

  return (
    <header className="sticky top-0 z-30 border-b-2 border-line bg-white">
      <div className="flex h-16 items-center justify-between gap-4 px-4 md:px-8">
        <button
          type="button"
          onClick={onMenuClick}
          aria-label="Buka menu admin"
          className="inline-flex h-[44px] w-[44px] items-center justify-center rounded-pill text-ink transition-colors duration-150 ease-out hover:bg-surface-2 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ink lg:hidden"
        >
          <Menu size={20} aria-hidden="true" />
        </button>

        <Link
          to="/"
          className="inline-flex min-h-[44px] items-center text-[14px] font-bold text-link no-underline transition-colors duration-150 ease-out hover:text-link-hover focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ink"
        >
          Lihat situs publik
        </Link>

        {user && (
          <UserMenu
            align="right"
            className="ml-auto"
            trigger={
              <span className="block text-right">
                <span className="block text-[14px] font-extrabold text-ink">{user.name}</span>
                <span className="block text-[12px] font-semibold text-muted">Admin</span>
              </span>
            }
          />
        )}
      </div>
    </header>
  );
};

export default AdminHeader;
